import React from 'react';
export function Expert() {
  return <section className="py-24 bg-sand-50 bg-terrazzo" data-id="element-125">
      <div className="container mx-auto px-4" data-id="element-126">
        <div className="max-w-5xl mx-auto bg-white rounded-[2.5rem] overflow-hidden shadow-premium border border-sand-100" data-id="element-127">
          <div className="flex flex-col md:flex-row" data-id="element-128">
            <div className="md:w-2/5 relative" data-id="element-129">
              <div className="absolute inset-0 bg-sage-900/10 mix-blend-multiply z-10" data-id="element-130"></div>
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=800&auto=format&fit=crop" alt="Camila Suárez - Especialista" className="w-full h-full object-cover min-h-[400px] grayscale-[20%]" data-id="element-131" />
            </div>
            <div className="md:w-3/5 p-10 md:p-16 flex flex-col justify-center relative" data-id="element-132">
              <div className="absolute top-10 right-10 opacity-10" data-id="element-133">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-134">
                  <path d="M12 2L15 9L22 12L15 15L12 22L9 15L2 12L9 9L12 2Z" fill="#C5A059" data-id="element-135" />
                </svg>
              </div>

              <span className="text-terracotta-500 font-bold tracking-widest uppercase text-xs mb-3" data-id="element-136">
                Conoce a tu instructora
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-semibold text-concrete-900 mb-2" data-id="element-137">
                Hola, soy Camila Suárez
              </h2>
              <p className="text-sage-600 text-sm md:text-base mb-8 uppercase tracking-wide font-medium" data-id="element-138">
                Especialista en Arte y Decoración con Cemento
              </p>

              <div className="space-y-5 text-concrete-600 font-light leading-relaxed" data-id="element-139">
                <p data-id="element-140">
                  Hace más de 10 años, buscaba una forma de decorar mi hogar sin
                  gastar una fortuna. Descubrí el cemento, pero mis primeros
                  intentos fueron un desastre: piezas rotas, burbujas por todos
                  lados y mucha frustración.
                </p>
                <p data-id="element-141">
                  Después de meses de prueba y error, perfeccioné una técnica
                  infalible. Hoy, no solo decoro espacios increíbles, sino que
                  he enseñado a más de 5.000 alumnas en toda Latinoamérica a
                  descubrir su lado creativo y a crear su propia fuente de
                  ingresos desde casa.
                </p>
                <p className="font-medium text-concrete-800 italic text-lg mt-4" data-id="element-142">
                  "Mi misión es acortar tu curva de aprendizaje para que
                  disfrutes del proceso desde el día uno."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}